import React from "react";
import classNames from "classnames";
import { UserTypingEvent } from "../../models/base/Conversation";
import { ChatMessage } from "@fidget/common/components/mstchat/chatMessage";
import { TooltipComponent } from "@fidget/common/components/tooltipComponent";
import { Avatar } from "@fidget/common/components/avatar/avatar";
import { DotLoader, DotStyleType } from "@fidget/common/components/loader/dotLoader";
import chatMessageStyles from "./ChatMessage.css";
import chatSectionStyles from "./chatSection.css";
import { intl } from "@fidget/common/i18n/TypedIntl";

interface Props {
  userTypingEvent: UserTypingEvent;
}

export const MessageTypingPreview = ({ userTypingEvent }: Props) => {
  return (
    <div className={classNames(chatSectionStyles.section, chatSectionStyles.dashboard)}>
      <DotLoader dotType={DotStyleType.DASHBOARD}
        loadingText={`${userTypingEvent.profile.displayedName} ${intl.formatMessage(
          "conversation.typing.isTyping"
        )}:`}
      />
      <div className={chatSectionStyles.content}>
        <TooltipComponent
          positionPreset={"top"}
          text={userTypingEvent.profile.displayedName}
          maxWidth={"80px"}
          breakWords
          changeTransformTooltip="translateX(-35%)"
          changeTransformOutset="translateX(-50%)"
        >
          <div className={chatSectionStyles.avatar}>
            <Avatar user={userTypingEvent.profile} />
          </div>
        </TooltipComponent>
        <div className={chatSectionStyles.space} />
        <div className={chatSectionStyles.items}>
          <div key={userTypingEvent.profile.id} className={chatMessageStyles.wrapper}>
            <ChatMessage text={userTypingEvent.preview || " "} alignRight={false} isPreview />
          </div>
        </div>
      </div>
    </div>
  );
};
